/*
 * Cliente minimo para el proyecto Supabase "orocash-conteo" (Trafico: conteo de personas por
 * camara en cada tienda). Mismo mecanismo que el sistema IGI original: fetch directo a las RPC
 * de Supabase con la anon key, sin el SDK @supabase/supabase-js (no agrega una dependencia nueva
 * al frontend). La anon key es de solo lectura (estas RPC son de consulta unicamente) y ya
 * viajaba publica en el cliente del sistema original.
 */
const SUPA_URL = "https://hvmthlrapokrymhhlzzi.supabase.co";
const SUPA_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2bXRobHJhcG9rcnltaGhsenppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0ODM5MjEsImV4cCI6MjA5ODA1OTkyMX0.ZKhLd21b1JkQGchrL7tGpU6g5z5X9WKtdnYqNsaKiqY";

async function sbRpc(fn, params) {
    const respuesta = await fetch(`${SUPA_URL}/rest/v1/rpc/${fn}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            apikey: SUPA_KEY,
            Authorization: `Bearer ${SUPA_KEY}`,
        },
        body: JSON.stringify(params),
    });
    if (!respuesta.ok) {
        const texto = await respuesta.text();
        throw new Error(`${fn}: ${texto}`);
    }
    return respuesta.json();
}

export const getRankingDevices = (from, to, deviceIds) =>
    sbRpc("get_ranking_devices", {p_from: from, p_to: to, p_device_ids: deviceIds});

export const getChartDevices = (from, to, deviceIds) =>
    sbRpc("get_chart_devices", {p_from: from, p_to: to, p_device_ids: deviceIds});

export const getHourlyDevices = (from, to, deviceIds) =>
    sbRpc("get_hourly_devices", {p_from: from, p_to: to, p_device_ids: deviceIds});
